// extracted by mini-css-extract-plugin
export default {"photoCarouselImage":"PhotoCarousel_photoCarouselImage__-SExk"};